var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.186 2.025H3.78c-.487 0-.886.36-.886.803v15.553c0 .444.288.557.647.246l6.084-5.254a.42.42 0 0 1 .518-.004l6.278 5.27c.36.303.652.186.652-.258V2.828c0-.443-.395-.803-.887-.803Zm-.443 14.403-4.7-3.947a1.796 1.796 0 0 0-1.157-.411c-.425 0-.846.14-1.174.423l-4.489 3.879V3.236h11.52v13.192Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.605 2.82c0-.628.554-1.084 1.164-1.084H16.2c.615 0 1.163.457 1.163 1.084v15.57c0 .265-.089.56-.366.67-.262.104-.534-.024-.739-.196L9.97 13.589c-.04-.033-.127-.032-.166.001l-6.094 5.26c-.202.174-.473.31-.736.208-.28-.108-.368-.406-.368-.668V2.82Zm1.164-.524c-.366 0-.611.264-.611.524v15.57c0 .073.01.117.02.14a.517.517 0 0 0 .173-.106l6.094-5.26.002-.002a.695.695 0 0 1 .871-.007l.002.002 6.29 5.276a.498.498 0 0 0 .178.102.367.367 0 0 0 .022-.145V2.82c0-.26-.242-.524-.612-.524H3.77Zm13.032 16.24H16.8ZM3.16 18.533Zm.777-15.584h12.094V17.03l-5.162-4.33a1.528 1.528 0 0 0-.983-.348c-.367 0-.723.121-.997.357l-4.952 4.275V2.948Zm.553.56v12.264l4.041-3.49c.383-.33.87-.49 1.355-.49.477 0 .953.156 1.335.476l4.257 3.571V3.51H4.49Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.1a80f3d05501f22cc15e1f6e562c70dd.svg";
export { ForwardRef as ReactComponent };